var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/consents/HipaaConsent.tsx";
import React, { useCallback, useState } from 'react';
import { VStack } from '@adc/parallax-component-library';
import { useApiError } from 'Hooks';
import { Button, Footer, Header, LogoActionBar, Main, RichText, ScrollContainer, Spinner } from 'Components/utility';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { getAuthSession } from 'Utilities/session';
import { store } from 'Utilities/store';
import { updateConsent } from 'Services/consent';
const HIPAA_CMS_CONFIG = {
  US: {
    titleKey: 'Hipaa.title',
    bodyTextKey: 'Hipaa.content.hipaaRichText.bodyText'
  },
  OUS: {
    titleKey: 'Consents.microcopy.consentsOptions.marketingConsentOUSTitle',
    bodyTextKey: 'Consents.microcopy.consentsOptions.marketingConsentOUSBody'
  }
};
const HipaaConsent = () => {
  const [loading, setLoading] = useState(false);
  const [authSession] = useState(() => getAuthSession());
  const {
    showApiErrorModal
  } = useApiError();
  const isUS = authSession?.country === 'US';
  const cmsConfig = isUS ? HIPAA_CMS_CONFIG.US : HIPAA_CMS_CONFIG.OUS;
  const handleSubmitHipaaAction = useCallback(async action => {
    try {
      setLoading(true);
      const {
        app
      } = store.getState().env;
      if (authSession) {
        const consentKey = authSession.country === 'US' ? 'hipaa' : 'crm';
        await updateConsent(authSession.accountId, action, app, consentKey, authSession.accessToken);
        mediator.publish('router:navigate', '/rwe');
        return;
      }
      showApiErrorModal();
    } catch {
      showApiErrorModal();
    } finally {
      setLoading(false);
    }
  }, [authSession, showApiErrorModal]);
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(LogoActionBar, {
    titleTestID: "Hipaa.actionTitle",
    title: i18n.t(cmsConfig.titleKey),
    noActionButton: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 7
    }
  }), loading && /*#__PURE__*/React.createElement(Spinner, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Header, {
    titleTestID: "Hipaa.title",
    title: i18n.t(cmsConfig.titleKey),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(VStack, {
    padding: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(RichText, {
    text: i18n.t(cmsConfig.bodyTextKey),
    testID: cmsConfig.bodyTextKey,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Footer, {
    customProps: /*#__PURE__*/React.createElement(VStack, {
      padding: "$4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 94,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onPress: () => handleSubmitHipaaAction('accept'),
      testID: "Hipaa.accept",
      label: i18n.t('Global.microcopy.common.accept'),
      "aria-label": i18n.t('Global.microcopy.common.accept'),
      marginBottom: "$4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 95,
        columnNumber: 13
      }
    }), /*#__PURE__*/React.createElement(Button, {
      onPress: () => handleSubmitHipaaAction('decline'),
      variant: "tertiary",
      testID: "Hipaa.decline",
      label: i18n.t('Global.microcopy.common.decline'),
      "aria-label": i18n.t('Global.microcopy.common.decline'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 102,
        columnNumber: 13
      }
    })),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 7
    }
  }));
};
export default HipaaConsent;